import { lang } from 'utils/lang'
import { isApp, getOS, isAbroad } from 'utils/utils'
const app = {
  state: {
    lang: lang,
    apiStatus: {
      code: 0,
      msg: ''
    },
    userInfo: {},
    isApp: isApp,
    OS: getOS(),
    isAbroad: isAbroad
  },
  mutations: {
    SET_API_STATUS: (state, apiStatus) => {
      state.apiStatus = apiStatus
    },
    SET_LANG: (state, language) => {
      state.lang = language
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    }
  }
}
export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js